import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import PrintProductGroup from './components/PrintProductGroup';
import { PrintProductSizesModal } from '../../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/components/PrintProductsGroup/components/PrintProductSizes';

const propTypes = {
  printProducts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  readOnly: PropTypes.bool,
  renderPrintProduct: PropTypes.func,
  onCartItemToggle: PropTypes.func.isRequired,
  getPrintProductSizePrice: PropTypes.func,
  disabled: PropTypes.bool,
  disabledElement: PropTypes.node,
  getCartItem: PropTypes.func,
};

const PrintProductsGroup = ({
  printProducts,
  onCartItemToggle,
  renderPrintProduct,
  readOnly,
  getPrintProductSizePrice,
  disabled,
  disabledElement,
  getCartItem,
}) => {
  const [selectedPrintProduct, setSelectedPrintProduct] = useState(null);

  return (
    <Fragment>
      {printProducts.map(printProduct => {
        if (renderPrintProduct) {
          return renderPrintProduct({
            printProduct,
            onPrintProductSelect: setSelectedPrintProduct,
            disabled,
            disabledElement,
          });
        }

        return (
          <PrintProductGroup
            key={printProduct.id}
            printProduct={printProduct}
            onPrintProductSelect={() => setSelectedPrintProduct(printProduct)}
            onPrintProductSizeSelected={printProductSize => {
              onCartItemToggle({
                printProduct,
                printProductSize,
              });
            }}
            readOnly={readOnly}
            getPrintProductSizePrice={getPrintProductSizePrice}
            disabled={disabled}
            disabledElement={disabledElement}
            hasIndividualSizeCartItem={
              printProduct.sizes?.total === 1 &&
              getCartItem?.({
                printProductId: printProduct.id,
                printProductSizeId: printProduct.sizes.records[0].id,
              })
            }
          />
        );
      })}
      {selectedPrintProduct && (
        <PrintProductSizesModal
          forceOpen
          prePaid
          onClose={() => setSelectedPrintProduct(null)}
          printProductId={selectedPrintProduct.id}
          printProduct={selectedPrintProduct}
          onPrintProductSizeSelect={printProductSize => {
            onCartItemToggle({
              printProduct: selectedPrintProduct,
              printProductSize,
            });
          }}
          getPrintProductSizePrice={getPrintProductSizePrice}
          getCartItem={getCartItem}
        />
      )}
    </Fragment>
  );
};

PrintProductsGroup.propTypes = propTypes;

export default PrintProductsGroup;
